










import Vue from 'vue'
import {fieldProps} from '../BZCore/ActiveField'
import Errors from '../errors.vue'

export default Vue.extend({
  name: 'CheckboxField',
  props: fieldProps,
  components: {Errors},
  created() {
    if (!this.value && this.defaultValue) {
      this.$emit('input', this.defaultValue)
    }
  },
  methods: {
    onInput(event: string) {
      this.$emit('input', event)
    }
  },
  computed: {
    currentValue: {
      get(): boolean {
        if (this.value) {
          return true;
        } else {
          return false;
        }
      },
      set() {

      }
    }
  }
})
